import React from 'react';
import classnames from 'classnames';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';

import { OrderSummaryContexts } from '../../../constants/AppConstants';
import { translate as t } from '../../../lib/I18n';

import Icon from '../../general/Icon';
import Price from '../../general/Price';
import FeatureFlag from '../../general/FeatureFlag';
import TripPlusbus from '../../checkout/TripPlusbus';
import PointTrip from '../../checkout/Trip';
import Fare from './Fare';
import DownloadTicketsModal from './DownloadTicketsModal';
import RemoveJourneyModal from './RemoveJourneyModal';
import OnEnterTrigger from '../../general/OnEnterTrigger';

class Trip extends PointTrip {

    _renderRemoveConfirm() {
        return (
            this.state.journeyToRemove && <RemoveJourneyModal
                orderTrip={this.props.orderTrip}
                onBack={this._handleRemoveJourneyBack}
                onConfirm={() => {
                    this._handleRemoveJourneyConfirm();
                    this.props.setBasketChanged();
                }}
            />
        );
    }

    render() {
        const { open } = this.state;
        const { order, orderTrip, index, context } = this.props;
        const fares = orderTrip.getJourneyFares();
        const titleKey = orderTrip.isSmartcard() ? 'smartcard_title' : 'journey_title';
        const tripTitle = t(`order.summary.${titleKey}`, { number: index + 1 });
        const TripTitleTag = context === OrderSummaryContexts.BASKET_MODAL ? 'h2' : 'h3';

        const classNames = classnames('order-summary__item', {
            'order-summary__item--expanded': open,
        });

        const dropDownClassNames = classnames('hidden-print text-secondary', {
            'otrl-rotate-180': open,
        });

        return (
            <li className={classNames}>
                {this._renderRemoveConfirm()}

                <div className="box-headed box-headed--primary">
                    <div className="box-headed__header box--padded text-weight--normal">
                        <Row>
                            <Col xs={8}>
                                <TripTitleTag className="journey-heading text-weight--normal">
                                    {tripTitle}
                                </TripTitleTag>
                            </Col>

                            <Col xs={4} className="text-right price">
                                <Price price={orderTrip.getTotalPrice()} />
                            </Col>
                        </Row>
                    </div>

                    <FeatureFlag name="enableTicketDownload">
                        {order.hasDownloadableTickets() &&
                            <div className="box box--padded box-headed__body">
                                <Row>
                                    <Col xsOffset={8} xs={4} className="text-right price">
                                        <Button onClick={this._showDownloads}>{t('order.summary.download.tickets')}</Button>
                                        {this.state.showDownloads && <DownloadTicketsModal onClose={this._closeDownloads} {...{ order, orderTrip }} />}
                                    </Col>
                                </Row>
                            </div>}
                    </FeatureFlag>

                    <div className="box-headed__body box--padded">
                        <p className="journey-toggler no-margin text-secondary text-weight--normal">
                            <OnEnterTrigger element="span" onClick={this._toggleOpen} className={dropDownClassNames}>
                                <Icon icon="dropdown" className={dropDownClassNames} />
                                {t('order.summary.journey_details')}
                            </OnEnterTrigger>

                            {this.renderRemoveJourney(tripTitle)}
                        </p>

                        {fares.map((fare, key) => (
                            <Fare
                                orderFare={fare}
                                key={key}
                                open={open}
                            />
                        ))}

                        <TripPlusbus orderTrip={orderTrip} open={open} />

                        {this.renderTripActions()}
                    </div>
                </div>
            </li>
        );
    }
}

export default Trip;
